var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lightest md:border-t md:mb-8\n  md:border-border-color"},[_c('div',{staticClass:"bg-custom md:pt-15 md:pb-6 bg-no-repeat bg-contain md:max-w-2xl m-auto",class:{
      'bg-else': !_vm.opportunityBackground,
      'bg-opportunity': _vm.opportunityBackground,
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }